import { useMemo } from 'react'

import { FilterDefinition, FiltersDefinition } from '@factorialco/f0-react/dist/experimental'
import { DocumentsSignatureStatusEnumValues } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { documentSignatureStatusLabel } from 'modules/documents/lib/Documents'

export type DocumentsFilterKeys = 'createdAt' | 'signatureStatus'

export type DocumentsFiltersDefinition = FiltersDefinition<DocumentsFilterKeys>

export const useFilters = (): {
  filters: DocumentsFiltersDefinition
  loading: boolean
} => {
  const filters: DocumentsFiltersDefinition = useMemo(() => {
    return {
      createdAt: {
        label: i18n.t('documents.employee.list.created_at'),
        type: 'date',
      } satisfies FilterDefinition,

      signatureStatus: {
        label: i18n.t('documents.employee.filters.esignature_status'),
        type: 'in',
        options: {
          options: DocumentsSignatureStatusEnumValues.map((status) => ({
            label: documentSignatureStatusLabel(status),
            value: status,
          })),
        },
      } satisfies FilterDefinition,
    }
  }, [])

  return { filters, loading: false }
}
